import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const GlassblowerIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 14.825 26.534">
    <path
      d="M2.75,26.534c-.013,0-.027,0-.041-.002l-.956-.083c-.128-.011-.246-.075-.325-.176-.079-.101-.113-.23-.094-.357.114-.744.243-1.491.379-2.282.433-2.515.881-5.115.856-7.69-.023-2.353-.509-4.677-.98-6.925-.132-.632-.257-1.23-.374-1.832-.049-.252.116-.496.368-.544.252-.049.496.116.544.368.115.595.239,1.189.371,1.818.48,2.292.976,4.662.999,7.107.025,2.66-.43,5.302-.87,7.857-.105.612-.206,1.198-.299,1.775l.46.04c.256.022.445.247.423.503-.021.242-.224.424-.462.424Z"
      fill="currentColor"
      opacity={0.9}
    />
    <path
      d="M9.422,25.378c-.035,0-.071-.004-.107-.013l-.7-.166c-.241-.057-.395-.293-.35-.536.335-1.822.406-4.521-.104-6.153-.024-.077-.204-.235-.362-.374-.537-.473-1.437-1.264-1.978-3.226-.466-1.69-.353-3.581-.254-5.25.061-1.025.119-1.994.009-2.651-.037-.222.091-.439.303-.514.212-.075.448.013.559.209.39.69.633,1.593.891,2.549.463,1.719.941,3.497,2.269,4.024.239.095.355.365.26.603-.095.239-.365.355-.603.26-1.689-.67-2.278-2.626-2.762-4.418-.095,1.595-.202,3.401.222,4.94.468,1.695,1.178,2.319,1.696,2.775.286.252.533.469.635.795.538,1.72.487,4.301.204,6.162l.277.066c.25.059.404.309.345.559-.051.214-.241.358-.452.358Z"
      fill="currentColor"
      opacity={0.9}
    />
    <path
      d="M3.526,12.285c-.658,0-1.051-.829-1.185-1.11-.324-.681-.646-1.724-.959-3.098-.057-.25.1-.499.35-.556.25-.057.499.1.556.35.597,2.621,1.067,3.285,1.228,3.445.102-.139.286-.532.432-1.39.154-.907.226-2.102.202-3.365-.002-.08.018-.159.056-.229l.651-1.207c.122-.226.404-.31.63-.188.226.122.31.404.188.629l-.594,1.1c.02,1.396-.072,2.692-.262,3.66-.247,1.262-.626,1.883-1.195,1.952-.033.004-.065.006-.097.006Z"
      fill="currentColor"
      opacity={0.9}
    />
    <path
      d="M3.488,5.553c-.601,0-1.258-.178-1.855-.508-.751-.416-1.306-1.025-1.525-1.67C-.071,2.844-.027,2.297.235,1.792c.274-.527.783-1.004,1.512-1.418C2.203.116,2.75-.016,3.287.002c.256.008.458.223.449.48s-.223.458-.48.449c-.369-.012-.742.078-1.051.253-.711.403-1.499,1.058-1.217,1.894.305.903,1.696,1.676,2.756,1.53.66-.09,1.015-.527,1.056-1.299.028-.523-.107-1.138-.353-1.606-.119-.227-.032-.508.195-.627.227-.119.508-.032.627.195.324.616.495,1.397.458,2.088-.066,1.226-.743,2.017-1.858,2.17-.124.017-.252.025-.382.025Z"
      fill="currentColor"
      opacity={0.9}
    />
    <path
      d="M3.369,2.974c-.23,0-.43-.171-.46-.406-.006-.044-.017-.136-.029-.167-.089-.241.034-.508.275-.597.241-.089.508.034.597.275.045.121.062.24.079.372.032.255-.148.487-.402.52-.02.003-.04.004-.059.004Z"
      fill="currentColor"
      opacity={0.9}
    />
    <path
      d="M4.125,2.92c-.229,0-.428-.169-.46-.402-.008-.058-.02-.11-.035-.176l-.013-.057c-.055-.251.103-.498.354-.554.251-.055.498.103.554.354l.012.052c.017.077.035.156.049.254.035.254-.143.489-.397.523-.021.003-.043.004-.064.004Z"
      fill="currentColor"
      opacity={0.9}
    />
    <path
      d="M3.926,4.509c-.255,0-.463-.206-.465-.462,0-.052-.005-.101-.011-.162l-.005-.056c-.023-.256.165-.482.421-.505.255-.024.482.165.505.421l.005.05c.007.071.015.152.015.246.001.257-.206.466-.462.467h-.003Z"
      fill="currentColor"
      opacity={0.9}
    />
    <path
      d="M11.658,17.444c-.159,0-.315-.082-.401-.23L3.712,4.354c-.13-.221-.056-.506.166-.636.221-.13.506-.056.636.166l7.545,12.86c.13.221.056.506-.166.636-.074.043-.155.064-.235.064Z"
      fill="currentColor"
    />
    <path
      d="M12.987,21.038c-.012,0-.024,0-.036,0-.212-.009-.31-.124-.488-.332-.083-.098-.214-.257-.365-.458-.258-.344-.606-.858-.798-1.349-.308-.786-.099-1.226.131-1.458.181-.182.475-.183.657-.002s.183.475.002.657c-.032.032-.069.313.356,1.013.232.383.507.734.679.94.161-.099.382-.295.505-.404.12-.106.233-.207.339-.283.208-.15.498-.104.649.104.15.208.104.498-.104.649-.069.05-.165.135-.267.225-.352.312-.787.698-1.259.698Z"
      fill="currentColor"
      opacity={0.9}
    />
    <path
      d="M14.361,20.001c-.157,0-.31-.08-.398-.224-.037-.061-.078-.129-.121-.202-.201-.336-.477-.797-.756-1.172-.389-.522-.572-.591-.597-.599-.253-.012-.45-.224-.442-.478.008-.252.214-.45.464-.45.005,0,.01,0,.014,0,.74.023,1.395,1.02,2.114,2.222.043.071.082.137.119.197.133.219.063.505-.156.638-.075.046-.158.067-.24.067ZM12.496,17.805h0,0Z"
      fill="currentColor"
      opacity={0.9}
    />
    <path
      d="M11.608,18.049c-.165,0-.324-.088-.409-.243-.079-.146-.165-.292-.247-.434-.172-.295-.35-.6-.495-.934-.102-.235.006-.509.242-.611.235-.102.509.006.611.242.123.283.279.551.445.835.086.148.175.3.261.458.123.225.039.508-.186.63-.071.038-.147.057-.222.057Z"
      fill="currentColor"
      opacity={0.9}
    />
    <path
      d="M12.397,17.847c-.134,0-.267-.057-.358-.169-.176-.213-.389-.577-.594-.93-.045-.076-.095-.163-.144-.245-.06.04-.126.074-.203.094-.249.063-.501-.088-.564-.337-.056-.221.058-.445.258-.536.017-.015.042-.038.06-.055.13-.123.307-.291.565-.283.283.009.433.243.543.414.083.13.183.3.288.48.17.291.381.652.508.807.163.198.136.491-.062.654-.087.072-.191.106-.296.106ZM11.572,16.269h0Z"
      fill="currentColor"
      opacity={0.9}
    />
  </SvgIcon>
);

export default GlassblowerIcon;
